
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import InstantSearch from 'vue-instantsearch';
import $ from "jquery";
import 'swipebox/src/css/swipebox.css';
import swipebox from 'swipebox';
import 'footable';
import VueObserveVisibility from 'vue-observe-visibility'

var unslider = require('unslider');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example', require('./components/Example.vue'));
Vue.use(InstantSearch);
Vue.component('algolia-instantsearch', require('./components/SearchBar.vue'));
Vue.component('algolia-instantsearch-page', require('./components/SearchResults.vue'));
Vue.use(VueObserveVisibility)

const nav = new Vue(
    {
        el: '#nav'
    }
);



// WEBPACK FOOTER //
// ./resources/assets/js/app.js